exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".insert-part-container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.btn-group {\n  max-width: fit-content;\n  margin-right: 20px;\n}\n\n.selects-cont {\n  width: 60%;\n  display: flex;\n  align-items: center;\n}\n\n.selects-cont .field {\n  width: 31% !important;\n  margin-right: 20px !important;\n  margin-bottom: 0 !important;\n}\n\n.selects-cont .field .field {\n  width: 100% !important;\n}\n.submit-btn {\n  width: fit-content;\n  margin-left: auto;\n}\n", ""]);

// exports
